<template>
  <div class="comment-item flex-1 flex flex-col overflow-hidden">
    <!-- 评论顶部信息 -->
    <div
      class="flex justify-between"
      :class="[$commentOptions.dense ? 'mb-1' : 'mb-2']"
    >
      <span class="teld-color-gray font-semibold">{{ userNameDisplay }}</span>
      <!-- <span :title="comment.CommentTime" class="teld-color-gray">{{ comment.CommentTimeRelative }}</span> -->
    </div>

    <!-- 评论内容行 -->
    <div
      class="comment-content"
      :class="[$commentOptions.dense ? 'mb-1' : 'mb-2']"
    >
      <div
        v-if="showCommentReference && comment.ReferenceTitle"
        :title="comment.ReferenceTitle"
        class="comment-content--reference teld-color-lightgray truncate"
        :class="[$commentOptions.dense ? 'mb-1 pl-1' : 'mb-2 pl-2']"
        style="border-left: 4px solid lightgray;"
      >
        {{ comment.ReferenceTitle }}
      </div>
      <div
        ref="commentContentRef"
        v-if="!comment.IsDeleted"
        v-html="decodeURIComponent(comment.Content)"
        @click="onClickContent"
      ></div>
      <div v-else class="teld-color-gray">该条评论已删除</div>
    </div>

    <!-- 附件 -->
    <section
      v-if="!comment.IsDeleted && comment.Attachments.length"
      class="attachments-section -ml-0.5"
      :class="[$commentOptions.dense ? 'mb-1' : 'mb-2']"
    >
      <div
        v-for="attachment in comment.Attachments"
        :key="attachment.ID"
        class="
          attachment-file flex items-center
          hover:text-theme-color cursor-pointer
        "
        :class="[$commentOptions.dense ? '' : 'py-1']"
        @click="handleDownloadFile(attachment)"
      >
        <!-- 文件类型图标 -->
        <FileTypeIcon :file-name="attachment.FileName" class="w-5 h-5 mr-2" />
        <!-- 文件名 -->
        <div
          class="flex-1 truncate overflow-hidden"
          :title="attachment.FileName"
        >
          {{ attachment.FileName }}
        </div>
      </div>
    </section>

    <!-- 评论底部按钮行 -->
    <div class="flex justify-between">
      <span :title="comment.CommentTime" class="teld-color-gray">
        {{ comment.CommentTimeRelative }}
      </span>
      <div
        class="comment-operations flex justify-end"
        :class="[disabled ? 'teld-color-lightgray' : 'teld-color-gray']"
      >
        <!-- TODO 各点击按钮是否加 Tab 导航 :tabindex="disabled ? -1 : 0" outline-on-focus -->
        <!-- 点赞 -->
        <div
          class="comment-like flex outline-on-focus rounded-sm leading-5"
          :class="[
            disabled
              ? 'cursor-not-allowed'
              : 'cursor-pointer hover:text-theme-color',
          ]"
          @click="onClickLike"
        >
          <SvgHeartFilled v-show="comment.Liked" class="mr-1" />
          <SvgHeart v-show="!comment.Liked" class="mr-1" />
          <span class="">{{ comment.LikeCount || 0 }}</span>
        </div>
        <!-- 收藏 -->
        <div
          class="comment-star flex ml-2 outline-on-focus rounded-sm leading-5 hidden"
          :class="[
            disabled
              ? 'cursor-not-allowed'
              : 'cursor-pointer hover:text-theme-color',
          ]"
          @click="onClickFavorite"
        >
          <SvgStarFilled v-show="comment.IsFavorite" class="mr-1" />
          <SvgStar v-show="!comment.IsFavorite" class="mr-1" />
          <span class="">
            {{ comment.FavoriteCount || 0 }}
          </span>
        </div>
        <!-- 回复 -->
        <div
          class="comment-reply ml-2 outline-on-focus rounded-sm"
          :class="[
            inputVisible ? 'teld-theme-color' : 'teld-color-gray',
            disabled
              ? 'cursor-not-allowed teld-color-lightgray'
              : 'cursor-pointer hover:text-theme-color',
          ]"
          @click="onClickReply"
        >
          {{ inputVisible ? '取消回复' : '回复' }}
        </div>
        <!-- 删除 -->
        <tp-popover v-if="comment.CanCancel && !disabled">
          <!-- <el-button slot="reference">删除</el-button> -->
          <div class="popover-content p-4" style="min-width:160px">
            <div class="mb-2">确定要删除吗？</div>
            <div class="flex justify-end">
              <span
                tabindex="0"
                class="mr-2 cursor-pointer"
                @click="hideConfirm"
              >
                取消
              </span>
              <span
                tabindex="0"
                class="teld-theme-color cursor-pointer"
                @click="onClickRevoke"
              >
                确定
              </span>
            </div>
          </div>

          <div
            slot="reference"
            class="comment-revoke ml-2 outline-on-focus rounded-sm hover:text-theme-color"
            :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer']"
          >
            删除
          </div>
        </tp-popover>
      </div>
    </div>

    <!-- 评论的回复框 -->
    <draft-editor
      ref="draftEditorRef"
      :visible="inputVisible"
      :placeholder="inputPlaceholder"
      class="w-full transition-all duration-300 overflow-hidden"
      :class="[
        inputVisible ? ($commentOptions.dense ? 'my-1' : 'my-2') : 'h-0',
      ]"
      @comment="onReplyToComment"
    />

    <!-- 本评论的回复列表Top2 -->
    <div
      v-show="comment.RepliesTop2.length"
      class="reply-list p-2 teld-bg-color-gray rounded"
      :class="$commentOptions.dense ? 'mt-1' : 'mt-2'"
    >
      <ReplyItem
        v-for="(reply, i) in comment.RepliesTop2"
        :key="reply.ID"
        :data-item="comment.RepliesTop2[i]"
        :is-comment-deleted="comment.IsDeleted"
        class="mr-1"
        :class="[i > 0 ? ($commentOptions.dense ? 'mt-1' : 'mt-2') : '']"
        @reply="onReplyToReply"
        @delete="onReplyDelete"
      />

      <div
        v-if="comment.ReplyCount > 2"
        class="
          teld-color-gray
          hover:text-theme-color
          text-center
        "
        :class="[
          disabled ? 'cursor-not-allowed' : 'cursor-pointer',
          $commentOptions.dense ? 'mt-1' : 'mt-2',
        ]"
        @click="showAllReplies"
      >
        查看全部 {{ comment.ReplyCount }} 条回复
      </div>
    </div>

    <CommentRepliesDialog
      :visible.sync="commentRepliesDialogVisible"
      :data-item="comment"
      @reply="onAddReplyInDialog"
      @delete-reply="onDeleteReplyInDialog"
    ></CommentRepliesDialog>

    <tp-image
      v-if="currentImgSrc"
      ref="imgPreviewRef"
      class="w-0 h-0"
      :src="currentImgSrc"
      :preview-src-list="previewSrcList"
      @load="onImageLoad"
    ></tp-image>
  </div>
</template>

<script>
// Components
import SvgHeart from '../../svg-icons/heart.vue';
import SvgHeartFilled from '../../svg-icons/heart-filled.vue';
import SvgStar from '../../svg-icons/star.vue';
import SvgStarFilled from '../../svg-icons/star-filled.vue';
import ReplyItem from '../reply-item/index.vue';
import DraftEditor from '../draft-editor/index.vue';
import CommentRepliesDialog from '../comment-replies-dialog/index.vue';
import FileTypeIcon from '../../file-type-icon/index.vue';

// Utils
import { relativeTime, saveAs, MENTIONED_USER_CLASS_NAME } from '../../../core';
import dayjs from 'dayjs';

export default {
  name: 'CommentItem',
  inject: [
    'loginUserInfo',
    'pageUrl',
    'showCommentReference',
    'showPersonnelInfo',
    'hidePersonnelInfo',
    'notificationLink',
  ],
  props: {
    dataItem: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    SvgHeart,
    SvgHeartFilled,
    SvgStar,
    SvgStarFilled,
    ReplyItem,
    DraftEditor,
    CommentRepliesDialog,
    FileTypeIcon,
  },
  data() {
    return {
      inputVisible: false,
      comment: {},
      commentRepliesDialogVisible: false,
      previewSrcList: [],
      currentImgSrc: '',
    };
  },
  computed: {
    disabled() {
      return this.comment.IsDeleted;
    },
    isAuthor() {
      const loginUser = this.loginUserInfo();
      return loginUser.userId === this.comment.UserID;
    },
    userNameDisplay() {
      return this.isAuthor ? '我' : this.comment.UserName;
    },
    inputPlaceholder() {
      return `回复 ${this.userNameDisplay}`;
    },
  },
  created() {
    const { CommentTime, ReplyCount, Replies } = this.dataItem;
    const timeRelative = relativeTime(CommentTime);
    const top2Replies = ReplyCount > 2 ? Replies.slice(0, 2) : Replies;

    this.comment = {
      ...this.dataItem,
      CommentTimeRelative: timeRelative || '',
      RepliesTop2: top2Replies,
      CommentTime: dayjs(CommentTime).format('YYYY/MM/DD HH:mm:ss'),
    };
  },
  mounted() {
    this.initImagePreview();
    this.initPersonnelInfo();
  },
  methods: {
    initImagePreview() {
      const elImages = this.$el.querySelectorAll('.comment-content img');
      this.previewSrcList = [].map.call(elImages, elImage => {
        return elImage.src;
      });
    },
    initPersonnelInfo() {
      const commentContentRef = this.$refs.commentContentRef;
      if (!commentContentRef) return;
      const elMentionedUsers = commentContentRef.querySelectorAll(
        `.${MENTIONED_USER_CLASS_NAME}`,
      );
      elMentionedUsers.forEach(el => {
        el.addEventListener('mouseenter', this.onEnter);
        el.addEventListener('mouseleave', this.onLeave);
      });
      console.log(`initPersonnelInfo`, elMentionedUsers);
    },
    onEnter(e) {
      this.showPersonnelInfo({ target: e.target });
    },
    onLeave() {
      this.hidePersonnelInfo();
    },
    async onClickLike() {
      if (this.disabled) return;
      const isLike = (this.comment.Liked = !this.comment.Liked);
      const diff = isLike ? 1 : -1;
      this.comment.LikeCount += diff;
      let succeeded = false;

      const payload = isLike
        ? { CommentID: this.comment.ID, TargetID: 0 }
        : { Id: this.comment.ID };
      const serviceCode = isLike ? 'CMTS-Like' : 'CMTS-CancelLike';
      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl(serviceCode),
          data: isLike
            ? { comment: JSON.stringify(payload) }
            : { input: JSON.stringify(payload) },
        });

        if (data.state !== '1') {
          return;
        }

        succeeded = true;
        // this.$TP.$message.success(isLike ? '已点赞' : '已取消点赞');
      } catch (error) {
        console.log(error);
      } finally {
        // 接口调用失败后，页面状态回滚
        if (!succeeded) {
          this.comment.Liked = !isLike;
          this.comment.LikeCount -= diff;
        }
      }
    },
    async onClickFavorite() {
      if (this.disabled) return;
      this.comment.IsFavorite = !this.comment.IsFavorite;
      const diff = this.comment.IsFavorite ? 1 : -1;
      this.comment.FavoriteCount += diff;
      // TODO 调接口
    },
    onClickReply() {
      if (this.disabled) return;
      this.inputVisible = !this.inputVisible;
    },
    hideConfirm() {
      document.body.click();
    },
    async onClickRevoke() {
      if (this.disabled) return;
      this.hideConfirm();
      this.inputVisible = false;
      this.comment.IsDeleted = true;

      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('CMTS-CancelComment'), // + `&id=${this.comment.ID}`,
          // method: 'GET',
          data: { id: this.comment.ID },
        });

        if (data.state !== '1') {
          this.comment.IsDeleted = false;
          this.comment.CanCancel = false;
          this.$TP.$message.error(data.errmsg);
          return;
        }
        this.$TP.$message.success('已删除');
        this.$emit('decrease', this.comment.ReplyCount + 1);
      } catch (error) {
        this.comment.IsDeleted = false;
        this.comment.CanCancel = false;
        this.$TP.$message.error('删除失败');
        console.log(error);
      }
    },
    async onReplyToComment(draftInfo) {
      const loginUser = this.loginUserInfo();
      const { content, fileList, userIdList, onSucceed, onFail } = draftInfo;
      const newCommentReply = {
        // 接口必传字段：
        CommentID: this.comment.ID,
        Content: content,
        Dimension: '', //
        UserAvatar: loginUser.avatar,
        Attachments: fileList.map(n => n.result),
        MentionedUsers: JSON.stringify(userIdList),
        Url: this.notificationLink(),
        UrlParams: JSON.stringify({
          fpath: encodeURIComponent(this.pageUrl),
          showComment: true,
          commentId: this.comment.ID,
        }),
        // TODO
        // Attachments: [
        //   {
        //     "CommentID": null,
        //     "AttachmentType": 2,
        //     "AttachmentUrl": "http://resource.teld3.xyz/telddoc/160/ae193012d0ed44bc8f535bb1b997ab5f.docx",
        //     "UploadTime": "2024-02-27T14:56:15.0019732+08:00",
        //     "FileName": "附件上传的方式对比.docx",
        //     "ID": "0934423e-4cd3-4fa7-9861-2e39261075a1",
        //     "Creator": null,
        //     "CreateTime": "0001-01-01T00:00:00",
        //     "LastModifier": null,
        //     "LastModifyTime": "0001-01-01T00:00:00"
        //   },
        //   {
        //     "CommentID": null,
        //     "AttachmentType": 2,
        //     "AttachmentUrl": "http://resource.teld3.xyz/telddoc/160/c589cc00324d4a29963aefcd33424fb5.zip",
        //     "UploadTime": "2024-02-27T14:56:05.4400198+08:00",
        //     "FileName": "empty-新建压缩(zipped)文件夹.zip",
        //     "ID": "c7d0a09a-48bd-4774-b62c-86c451128c1d",
        //     "Creator": null,
        //     "CreateTime": "0001-01-01T00:00:00",
        //     "LastModifier": null,
        //     "LastModifyTime": "0001-01-01T00:00:00"
        //   },
        //   {
        //     "CommentID": null,
        //     "AttachmentType": 0,
        //     "AttachmentUrl": "http://resource.teld3.xyz/teldimage/160/d46fdb8df2b6482982818feddf44f083.png",
        //     "UploadTime": "2024-02-27T14:55:45.6408044+08:00",
        //     "FileName": "F4D2D99C-AB85-4ff7-BDC0-7CB5803C0341.png",
        //     "ID": "434540c6-6a00-4639-ad22-0b8630f5efcc",
        //     "Creator": null,
        //     "CreateTime": "0001-01-01T00:00:00",
        //     "LastModifier": null,
        //     "LastModifyTime": "0001-01-01T00:00:00"
        //   },
        // ],
      };

      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('CMTS-SaveReply'),
          data: { reply: JSON.stringify(newCommentReply) },
        });
        console.log('SaveReply', data);
        if (data.state !== '1' || !data.data) {
          onFail();
          return;
        }

        // TODO 接口没有返回新数据对象，暂时用前端数据
        Object.assign(newCommentReply, {
          ID: 'comment-reply-m-' + parseInt(Math.random() * 1000), // TODO UI-mock
          ReplyTime: Date().toLocaleString(), // TODO UI-mock
          UserID: loginUser.userId, // TODO UI-mock
          UserName: loginUser.userName, // TODO UI-mock
          Liked: false, // TODO UI-mock
          LikeCount: 0, // TODO UI-mock
          IsFavorite: false, // TODO UI-mock
          FavoriteCount: 0, // TODO UI-mock
          IsDeleted: false, // TODO UI-mock
          CanCancel: true, // TODO UI-mock
        });

        // 调接口成功后清空输入框内容
        onSucceed();
        this.inputVisible = false;
        // 评论完将新添加评论展示出来
        this.comment.RepliesTop2.unshift(
          (data && data.data) || newCommentReply,
        );
        this.comment.ReplyCount += 1;
        this.$emit('increase');
      } catch (error) {
        console.log(error);
        onFail();
      }
    },
    onReplyToReply(data) {
      this.comment.RepliesTop2.unshift(data);
      this.comment.ReplyCount += 1;
      this.$emit('increase');
    },
    onReplyDelete(data) {
      this.comment.ReplyCount -= 1;
      this.comment.RepliesTop2.some(n => {
        if (n.ID === data.ID) {
          n.IsDeleted = true;
          return true;
        }
      });
      this.$set(this.comment, 'RepliesTop2', this.comment.RepliesTop2);
      this.$emit('decrease');
    },
    showAllReplies() {
      if (this.disabled) return;
      this.commentRepliesDialogVisible = true;
    },
    onAddReplyInDialog() {
      this.comment.ReplyCount += 1;
      this.$emit('increase');
    },
    onDeleteReplyInDialog(data) {
      this.onReplyDelete(data);
    },
    onImageLoad(e) {
      e.target.click();
    },
    onClickContent(e) {
      const el = e.target;
      if (el.nodeName === 'IMG' && el.currentSrc) {
        this.currentImgSrc = '';
        this.$nextTick(() => {
          this.currentImgSrc = el.currentSrc;
        });
      }
    },
    handleDownloadFile(attachment) {
      const { AttachmentUrl, FileName } = attachment;
      saveAs({
        url: AttachmentUrl,
        fileName: FileName,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
